var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.860352H513V342.827H0V0.860352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.860352H513V114.883H0V0.860352Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.905H513V342.927H0V228.905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.73 205.66C220.73 205.66 220.73 147.146 225.239 140.833C228.345 136.525 242.072 146.043 247.983 145.342C247.983 145.342 252.192 137.827 252.492 133.319C252.793 128.71 251.39 125.704 247.583 127.107C247.583 127.107 246.38 125.002 248.084 123.8C249.687 122.598 253.694 123.9 253.694 123.9C253.694 123.9 253.194 122.898 255.298 122.998C258.203 123.199 262.512 124.401 262.712 128.609C262.912 131.715 263.013 136.324 263.113 137.326C263.814 144.14 265.818 146.043 265.818 146.043C265.818 146.043 284.254 136.825 287.861 140.833C291.168 144.641 292.37 205.66 292.37 205.66L274.235 188.827L286.358 218.384C286.358 218.384 271.93 220.789 257.402 220.789C242.873 220.789 226.241 216.581 226.241 216.581L240.068 188.326L220.73 205.66Z",
    fill: "#C09300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.860352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEg);
export default __webpack_public_path__ + "static/media/EG.f9ee58f26379cf3b3339f1d2e403a08b.svg";
export { ForwardRef as ReactComponent };